module.exports = __webpack_public_path__ + "img/pdf-icon.78d33d33.svg";